import { render } from "./Inputs.vue?vue&type=template&id=1b221c59"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"
script.render = render

export default script